import React, { useRef, useState } from 'react';
import { Datagrid, TextField, useRefresh } from 'react-admin';

import { makeStyles } from '@material-ui/core/styles';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ClearIcon from '@material-ui/icons/Clear';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import EditLocationOutlinedIcon from '@material-ui/icons/EditLocationOutlined';
import MapOutlinedIcon from '@material-ui/icons/MapOutlined';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { useSnackbar } from 'notistack';

import { DialogoConfirmacao } from '../../Components';
import ActionsList from '../../Components/ReactAdmin/ActionsList';
import ActionsField from '../../Components/ReactAdmin/Fields/ActionsField';
import ListPageTabbed from '../../Components/ReactAdmin/List/ListPageTabbed';
import { ProtegerPagina } from '../../layout/VerificaPermissaoPage';
import { api } from '../../services';
import { PRIMARY_COLOR } from '../../utils';
import { STATUS_ATIVO, STATUS_INATIVO } from '../../utils/constants';
import { PERMISSAO_TELA_MAPAS_LOJA_LISTAR } from '../../utils/dadosTelas';
import DialogoMapaLoja from '../EnderecoExposicaoMercadorias/DialogoMapaLoja';
import DialogoVisualizarMapaLoja from '../EnderecoExposicaoMercadorias/DialogoVisualizarMapaLoja';
import DialogoCreateEdit from './DialogoCreateEdit';
import DialogoEscolherMapaEAndar from './DialogoEscolherMapaEAndar';

const tabs = [
  { id: 'ativos', name: 'Ativos', filter: { status: STATUS_ATIVO } },
  { id: 'inativos', name: 'Inativos', filter: { status: STATUS_INATIVO } },
];

const useStyles = makeStyles((theme) => ({
  dataHeader: {
    flex: 1,
    backgroundColor: PRIMARY_COLOR,
    padding: '10px',
    color: 'white',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
    borderSpacing: 0,
    borderCollapse: 'collapse',
    '& .MuiTableSortLabel-root.MuiTableSortLabel-active': {
      color: 'red',
    },
    '& .MuiTableSortLabel-root.MuiTableSortLabel-active .MuiTableSortLabel-icon': {
      color: 'red !important',
    },
  },
  dataCell: {
    flex: 1,
    padding: '10px',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
}));

const MapasLojaList = (props) => {
  const refresh = useRefresh();
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const refDialogoConfirmacao = useRef(null);
  const refDialogoMapaLoja = useRef(null);
  const refDialogoVisualizarMapaLoja = useRef(null);
  const refDialogoVisualizarMapaLoja1Aereo = useRef(null);
  const refDialogoVisualizarMapaLoja2Aereo = useRef(null);
  const refDialogoEscolherMapaEAndar = useRef(null);

  const [dialogo, setDialogo] = useState({ open: false, id: null });

  function handleEscolherMapaEAndar() {
    if (refDialogoEscolherMapaEAndar.current) refDialogoEscolherMapaEAndar.current.handleOpen();
  }

  function handleCriar() {
    setDialogo({ open: true, id: null });
  }

  function handleEdit(record) {
    setDialogo({ open: true, id: record.id });
  }

  function handleAbrirMapa(record) {
    if (refDialogoMapaLoja.current) refDialogoMapaLoja.current.handleOpen(record.id);
  }

  function handleVisualizar(record) {
    if (refDialogoVisualizarMapaLoja.current) refDialogoVisualizarMapaLoja.current.handleOpen(record.id);
  }

  function handleVisualizar1Aereo(record) {
    if (refDialogoVisualizarMapaLoja1Aereo.current) refDialogoVisualizarMapaLoja1Aereo.current.handleOpen(record.id);
  }

  function handleVisualizar2Aereo(record) {
    if (refDialogoVisualizarMapaLoja2Aereo.current) refDialogoVisualizarMapaLoja2Aereo.current.handleOpen(record.id);
  }

  function handleAtivar(record) {
    if (refDialogoConfirmacao.current) {
      refDialogoConfirmacao.current.handleOpen(
        'ATIVAR MAPA',
        `Tem certeza que deseja ativar o mapa "${record.nome}"?`,
        { id: record.id, codigo: 1 },
      );
    }
  }

  function handleDesativar(record) {
    if (refDialogoConfirmacao.current) {
      refDialogoConfirmacao.current.handleOpen(
        'DESATIVAR MAPA',
        `Tem certeza que deseja desativar o mapa "${record.nome}"?`,
        { id: record.id, codigo: 2 },
      );
    }
  }

  async function ativar(id) {
    const response = await api.put(`/mapas_loja/status/ativar/${id}`);
    if (response.data.status) {
      refresh();
    } else {
      enqueueSnackbar(response.data.message, { variant: 'error' });
    }
  }

  async function desativar(id) {
    const response = await api.put(`/mapas_loja/status/inativar/${id}`);
    if (response.data.status) {
      refresh();
    } else {
      enqueueSnackbar(response.data.message, { variant: 'error' });
    }
  }

  async function handleConfirma({ id, codigo }) {
    switch (codigo) {
      case 1:
        return ativar(id);
      case 2:
        return desativar(id);
      default:
    }
  }

  const toolbarActions = (
    <ActionsList
      handleCriar={handleCriar}
      actions={[
        {
          label: 'Visualizar Mapa',
          icon: <VisibilityIcon />,
          onClick: handleEscolherMapaEAndar,
        },
      ]}
      {...props}
    />
  );

  const renderGrid = () => (
    <Datagrid bulkActionButtons={false}>
      <TextField
        source="nome"
        label="Nome"
        headerClassName={classes.dataHeader}
        cellClassName={classes.dataCell}
      />
      <TextField
        source="largura"
        label="Largura"
        headerClassName={classes.dataHeader}
        cellClassName={classes.dataCell}
        sortable={false}
      />
      <TextField
        source="altura"
        label="Altura"
        headerClassName={classes.dataHeader}
        cellClassName={classes.dataCell}
        sortable={false}
      />
      <ActionsField
        textAlign="right"
        label="Ações"
        sortable={false}
        headerClassName={classes.dataHeader}
        cellClassName={classes.dataCell}
        maxAcoesVisiveis={2}
        actions={[
          {
            title: 'Editar',
            icon: <EditOutlinedIcon />,
            show: () => true,
            onClick: (r) => handleEdit(r),
          },
          {
            title: 'Editar Mapa (arrastar endereços)',
            icon: <EditLocationOutlinedIcon />,
            show: () => true,
            onClick: (r) => handleAbrirMapa(r),
          },
          {
            title: 'Visualizar Térreo',
            icon: <VisibilityIcon />,
            show: () => true,
            onClick: (r) => handleVisualizar(r),
          },
          {
            title: 'Visualizar 1º Aéreo',
            icon: <MapOutlinedIcon />,
            show: () => true,
            onClick: (r) => handleVisualizar1Aereo(r),
          },
          {
            title: 'Visualizar 2º Aéreo',
            icon: <MapOutlinedIcon />,
            show: () => true,
            onClick: (r) => handleVisualizar2Aereo(r),
          },
          {
            title: 'Ativar',
            icon: <CheckCircleOutlineIcon />,
            show: (r) => r.status === STATUS_INATIVO,
            onClick: (r) => handleAtivar(r),
          },
          {
            title: 'Desativar',
            icon: <ClearIcon />,
            show: (r) => r.status === STATUS_ATIVO,
            onClick: (r) => handleDesativar(r),
          },
        ]}
      />
    </Datagrid>
  );

  return (
    <ProtegerPagina permissao={PERMISSAO_TELA_MAPAS_LOJA_LISTAR}>
      <>
        <ListPageTabbed
          title="Mapas da Loja"
          toolbarActions={toolbarActions}
          renderGrid={renderGrid}
          perPage={20}
          tabs={tabs}
          filterDefaultValues={{ status: STATUS_ATIVO }}
          listProps={{ sort: { field: 'nome', order: 'asc' }, ...props }}
        />

        <DialogoConfirmacao
          ref={refDialogoConfirmacao}
          handleConfirma={handleConfirma}
        />
        <DialogoCreateEdit
          open={dialogo.open}
          id={dialogo.id}
          onClose={() => {
            setDialogo({ open: false, id: null });
            refresh();
          }}
          isDialogoConfirmacaoActions
        />
        <DialogoMapaLoja ref={refDialogoMapaLoja} />
        <DialogoVisualizarMapaLoja
          ref={refDialogoVisualizarMapaLoja}
          andarFiltro={1}
          titulo="Térreo"
        />
        <DialogoVisualizarMapaLoja
          ref={refDialogoVisualizarMapaLoja1Aereo}
          andarFiltro={2}
          titulo="1º Aéreo"
        />
        <DialogoVisualizarMapaLoja
          ref={refDialogoVisualizarMapaLoja2Aereo}
          andarFiltro={3}
          titulo="2º Aéreo"
        />
        <DialogoEscolherMapaEAndar ref={refDialogoEscolherMapaEAndar} />
      </>
    </ProtegerPagina>
  );
};

export default MapasLojaList;
